import { render, staticRenderFns } from "./SingleOrderDetails.vue?vue&type=template&id=79a5215a&scoped=true"
import script from "./SingleOrderDetails.vue?vue&type=script&lang=js"
export * from "./SingleOrderDetails.vue?vue&type=script&lang=js"
import style0 from "./SingleOrderDetails.vue?vue&type=style&index=0&id=79a5215a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a5215a",
  null
  
)

export default component.exports